
<template>
  <component :is="currentView" ref="demonProcess" :active="active" :operation-flag="operationFlag"></component>
</template>

<script>
import { mapGetters } from 'vuex';
import { proviedDbTypeMap } from '@/constants/dbms';
import WDemonprocessCubridTable from './DemonprocessCubridTable';
import WDemonprocessMsSqlTable from './DemonprocessMsSqlTable';
import WDemonprocessMysqlTable from './DemonprocessMysqlTable';
import WDemonprocessOracleTable from './DemonprocessOracleTable';
import WDemonprocessTiberoTable from './DemonprocessTiberoTable';

export default {
  name: 'WDemonProcess',
  components: {
    WDemonprocessCubridTable,
    WDemonprocessMsSqlTable,
    WDemonprocessMysqlTable,
    WDemonprocessOracleTable,
    WDemonprocessTiberoTable,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    operationFlag: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentView: null,
    };
  },
  computed: {
    ...mapGetters(['selectedNode']),
    objtypeId() {
      return this.selectedNode && this.selectedNode.obj ? this.selectedNode.obj.objtypeId : null;
    },
  },
  watch: {
    objtypeId: {
      immediate: true,
      handler() {
        this.changeView();
      },
    },
    active: {
      immediate: true,
      handler() {
        this.changeView();
      },
    },
  },
  methods: {
    changeView() {
      if (this.active) {
        if (this.objtypeId === proviedDbTypeMap.MYSQL) {
          this.currentView = WDemonprocessMysqlTable.name;
        } else if (this.objtypeId === proviedDbTypeMap.ORACLE) {
          this.currentView = WDemonprocessOracleTable.name;
        } else if (this.objtypeId === proviedDbTypeMap.MSSQL) {
          this.currentView = WDemonprocessMsSqlTable.name;
        } else if (this.objtypeId === proviedDbTypeMap.TIBERO) {
          this.currentView = WDemonprocessTiberoTable.name;
        } else if (this.objtypeId === proviedDbTypeMap.CUBRID) {
          this.currentView = WDemonprocessCubridTable.name;
        }
      }
    },
    loadData() {
      this.$nextTick(() => {
        this.$refs.demonProcess.loadData();
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/database/components/table/DemonProcess/index.vue